/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Email_Settings_SaveInputs */

const en_admin_email_settings_save = /** @type {(inputs: Admin_Email_Settings_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save`)
};

const de_admin_email_settings_save = /** @type {(inputs: Admin_Email_Settings_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Speichern`)
};

/**
* | output |
* | --- |
* | "Save" |
*
* @param {Admin_Email_Settings_SaveInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_email_settings_save = /** @type {((inputs?: Admin_Email_Settings_SaveInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Email_Settings_SaveInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_email_settings_save(inputs)
	return en_admin_email_settings_save(inputs)
});